import { render, staticRenderFns } from "./reviewPurchase.vue?vue&type=template&id=469d277a&scoped=true"
import script from "./reviewPurchase.vue?vue&type=script&lang=js"
export * from "./reviewPurchase.vue?vue&type=script&lang=js"
import style0 from "./reviewPurchase.vue?vue&type=style&index=0&id=469d277a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469d277a",
  null
  
)

export default component.exports